import request from '../utils/request';
import config from '../config';
// 生成脚本
export async function getScriptByObjectSelector({ sourceType, sourceName, type, typeName }) {
  const url = `${config.domain2}/api/metadata/script?sourceType=${sourceType}&sourceName=${sourceName}&type=${type}&typeName=${typeName}`;
  return request(typeName ? `${url}&name=${typeName}` : url);
}

